export default __webpack_public_path__ + "static/media/25.97eb619c.png";